import getSrpUrlParams, { getUnifiedSrpUrlParams } from './get-srp-url-params';
import isSEM from './is-sem';
import { SEO_SEARCH_STRING } from '@stencil/flights-constants/src/default-values';
import { SRP_URL, FLIGHTS_URL, UNIFIED_FLIGHTS_URL } from '@stencil/flights-constants/src/urls';

const getUnifiedSrpUrl = (
  searchWidgetData,
  selectedFareIdentifier,
  searchParams,
  extraQueryParams = {}
) => {
  try {
    const querySearchParams = new URLSearchParams(searchParams);
    selectedFareIdentifier =
      selectedFareIdentifier ||
      querySearchParams.get('ft') ||
      (querySearchParams.get('student') && 'student') ||
      '';
    const queryParams = getUnifiedSrpUrlParams(
      searchWidgetData,
      selectedFareIdentifier,
      extraQueryParams
    );
    return `${window.location.origin}${UNIFIED_FLIGHTS_URL}?${queryParams}`;
  } catch (e) {}

  return '';
};

const getSrpUrl = (
  searchWidgetData,
  searchParams,
  isGroundup = false,
  selectedFareIdentifier = '',
  isUnified = false,
  extraQueryParams = {}
) => {
  const DOMESTIC = 'domestic';
  const isDomestic = searchWidgetData?.travelType === DOMESTIC;
  const srpURLParams = getSrpUrlParams(searchWidgetData, isGroundup, selectedFareIdentifier);

  const isSem = isSEM();
  const searchString = isSem ? location?.search : `?${SEO_SEARCH_STRING}`;

  if (isUnified) {
    const url = getUnifiedSrpUrl(
      searchWidgetData,
      selectedFareIdentifier,
      searchParams,
      extraQueryParams
    );
    if (url) {
      return url;
    }
  }

  if (isGroundup && isDomestic) {
    return `${window.location.origin}${FLIGHTS_URL}air-${srpURLParams}/${searchString}${searchParams}`;
  }

  return `${window.location.origin}${SRP_URL}${srpURLParams}/${searchString}${searchParams}`;
};

export default getSrpUrl;
